export const VULNERABILITY_JIRA_TICKETS_LABELS = {
  SECTION_LABEL: 'Jira tickets',
  NO_TICKETS: 'No tickets yet',
  CREATE_TICKET: 'Create ticket',
  UNLINK: 'Unlink',
  TICKET_ID: 'Ticket ID',
  STATUS: 'Status',
  ASSIGNEE: 'Assignee',
  UPDATED: 'Updated',
  ACTIONS: 'Actions',
  UNLINK_MODAL_CANCEL: 'Cancel',
  UNLINK_MODAL_CONFIRM: 'Unlink',
  UNLINK_SUCCESS: 'Ticket unlinked successfully.',
  UNLINK_ERROR: 'Failed to unlink ticket.',
  OPEN_TICKET: 'Open ticket in Jira',
  TICKET_ACTIONS: 'Ticket actions'
};

export function getTicketCountLabel(count) {
  if (count === 1) {
    return '1 Ticket';
  }

  return `${count} Tickets`;
}

export function getUnlinkModalTitle(ticketKey) {
  return `Unlink ${ticketKey}?`;
}

export function getUnlinkModalMessage(ticketKey) {
  return `This will remove the link between this finding and ${ticketKey}. The ticket will remain in Jira.`;
}
